module.exports = {"310118001":"夏阳街道","310118002":"盈浦街道","310118003":"香花桥街道","310118102":"朱家角镇","310118103":"练塘镇","310118104":"金泽镇","310118105":"赵巷镇","310118106":"徐泾镇","310118107":"华新镇","310118109":"重固镇","310118110":"白鹤镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310118.json
// module id = 759
// module chunks = 0